import {mergeSxs} from '@hconnect/uikit/src/lib2'
import {SxProps, Theme} from '@mui/material'

// Single token-based filter input styling. Colours follow the ambient MUI theme:
// on the light page surface (Suite) tokens resolve to dark foreground; wrapped in
// the Fundamental contrast theme (legacy blue header) they resolve to white.
// Borders use the Fundamental `border_highlight_10` palette slot, matching the outlined filter buttons.
export const textFieldFilterSx: SxProps<Theme> = (theme) => ({
  width: 200,
  '& .MuiInputBase-root': {
    borderColor: theme.palette.borderHighlight,
    '&:hover': {
      borderColor: theme.palette.borderHighlight
    },
    '&.Mui-focused': {
      borderColor: theme.palette.primary.main
    }
  },
  '& label.MuiFormLabel-root': {
    color: 'text.secondary',
    '&:hover': {
      color: 'text.primary'
    }
  },
  '& input:-webkit-autofill, input:-webkit-autofill:focus, input:-webkit-autofill:hover': {
    // HACK: this is a rather ugly hack to prevent the Browser from overriding the text field's color
    // see also https://stackoverflow.com/questions/61083813/how-to-avoid-internal-autofill-selected-style-to-be-applied
    transition: 'background-color 600000s 0s, color 600000s 0s'
  },
  '& .MuiOutlinedInput-root': {
    color: 'text.primary',
    backgroundColor: 'transparent',
    '& fieldset': {
      borderColor: theme.palette.borderHighlight
    },
    '&:hover fieldset': {
      borderColor: theme.palette.borderHighlight
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.primary.main
    }
  },
  '& .MuiFilledInput-root': {
    color: 'text.primary',
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent'
    },
    '&.Mui-focused': {
      backgroundColor: 'transparent'
    }
  }
})

export const selectFieldFilterSx: SxProps<Theme> = mergeSxs(textFieldFilterSx, {
  '& .MuiSvgIcon-root': {
    color: 'text.primary'
  }
})
